<template>
  <div>
    <div
      :class="{
        'nav-btn d-none d-lg-flex flex-column align-items-center justify-content-center mx-2': true,
        selected: isOpen,
      }"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
      id="device-drop-toggle"
    >
      <img src="../../assets/nav-icons/provision-device.svg" />
      <div class="pt-2">
        <span>Device</span>
      </div>
    </div>

    <div class="btn-group mr-2 d-none d-lg-block">
      <div class="dropdown-menu dropdown-menu-right">
        <ul v-if="deviceInfo.hasInfo" class="list-group list-group-flush">
          <li class="list-group-item bg-white">
            <span class="font-weight-bold">ID:</span>
            <span class="float-right text-capitalize">{{
              deviceInfo.device_id
            }}</span>
          </li>
          <li class="list-group-item bg-white">
            <span class="font-weight-bold">Product:</span>
            <span class="float-right">
              {{ productName(deviceInfo.product) }}
            </span>
          </li>
        </ul>
        <ul v-if="!deviceInfo.hasInfo" class="list-group list-group-flush">
          <li class="list-group-item bg-white">No device info</li>
        </ul>
      </div>
    </div>
    <!-- ^ desktop ^ -->

    <div class="btn-group mr-2 d-block d-lg-none">
      <div id="accordion">
        <div class="card mt-2">
          <button
            id="deviceInfomation"
            class="card-header btn btn-primary d-flex py-3 rounded"
            data-toggle="collapse"
            data-target="#deviceInformation"
            aria-expanded="true"
            aria-controls="collapseOne"
          >
            <i class="material-icons" style="margin-right:7px">tablet</i>
            <span>Device</span>
          </button>
          <div
            id="deviceInformation"
            class="collapse"
            aria-labelledby="deviceInfomation"
            data-parent="#deviceInformation"
          >
            <div class="card-body">
              <div class>
                <ul
                  v-if="deviceInfo.hasInfo"
                  class="list-group list-group-flush"
                >
                  <li class="list-group-item bg-white">
                    <span class="font-weight-bold">ID:</span>
                    <span class="float-right text-capitalize">{{
                      deviceInfo.device_id
                    }}</span>
                  </li>
                  <li class="list-group-item bg-white">
                    <span class="font-weight-bold">Product:</span>
                    <span class="float-right">
                      {{ productName(deviceInfo.product) }}
                    </span>
                  </li>
                </ul>
                <ul
                  v-if="!deviceInfo.hasInfo"
                  class="list-group list-group-flush"
                >
                  <li class="list-group-item bg-white">No device info</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- ^ mobile ^ -->
</template>
<script>
import { validateProductName } from "../../utils/distributor.helper";

export default {
  name: "DeviceInformation",
  data: function() {
    return {
      isOpen: false,
    };
  },
  mounted() {
    // eslint-disable-next-line no-undef
    $("#device-drop-toggle")
      .parent()
      .on("hidden.bs.dropdown", () => {
        this.isOpen = false;
      });
    // eslint-disable-next-line no-undef
    $("#device-drop-toggle")
      .parent()
      .on("shown.bs.dropdown", () => {
        this.isOpen = true;
      });
  },
  computed: {
    deviceInfo() {
      return this.$store.getters.getDeviceInfo;
    },
  },
  methods: {
    productName(product) {
      return validateProductName(product);
    },
  },
};
</script>

<style scoped>
@media (max-width: 991px) {
  .btn-group {
    width: 100%;
  }
}

.btn.btn-primary.dropdown-toggle-right {
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}

.bg-white {
  background: var(--white);
}
</style>
